<template>
	<div :class="['uploader', {'compact':compact}]">
        <input type="hidden" :name="useFieldName" :value="useValue" ref="hiddenField">
        <div class="dropzone" ref="dropzone"></div>
	</div>
</template>

<script>
    export default {
        props: {
            fieldName:  {
                type: String,
                default: ''
            },
            value: {
                default: ''
            },
            compact: {
                type: Boolean,
                default: false
            },
            uploadText: {
                type: String,
                default: window.t('general_upload_message'),
            },
        },
        data() {
            return {
                window,
                useFieldName: '',
                lastSuccessFile: null,
                lastSuccessFileUrl: null,
                thisDropzone: null,
                useValue: '',
            }
        },
        created() {
            if (this.fieldName == '') {
                this.useFieldName = 'uploader_'+this.uniqid()
            } else {
                this.useFieldName = this.fieldName;
            }

            this.useValue = this.value
        },
        mounted() {
            var vm = this;

            var useTypeName = this.typeName;

            $(this.$refs.dropzone).dropzone({
                url:'/audio-upload',
                thumbnailWidth:null,
                dictDefaultMessage:'<img src="/images/upload-cloud.svg" alt="" class="cloud"> <div class="label">' + this.uploadText + '</div> <div class="label2">' + window.t('general_upload').toUpperCase() + '</div>',
                dictRemoveFile: window.t('general_delete_upload'),
                maxFiles: 1,
                addRemoveLinks: true,
                maxfilesexceeded(file) {
                    this.removeAllFiles();
                    this.addFile(file);
                },
                init() {
                    this.on('removedfile', function (file) {
                        vm.useValue = '';
                        vm.$emit('update:value','');
                    });

                    vm.thisDropzone = this;

                    if (vm.useValue != '') {
                        axios
                            .post('/audio-upload/files',{files: [vm.useValue]})
                            .then(function(response) {
                                if (response.data.files) {
                                    for (var key in response.data.files) {
                                        var mockFile = { name: response.data.files[key].name, size: response.data.files[key].size,accepted: true, status: 'success', upload: {progess: 100, total: response.data.files[key].size, bytesSent: response.data.files[key].size} }; // here we get the file name and size as response

                                        vm.lastSuccessFile = mockFile;
                                        vm.lastSuccessFileUrl = response.data.files[key].url;

                                        vm.thisDropzone.options.addedfile.call(vm.thisDropzone, mockFile);
                                        vm.thisDropzone.files.push(mockFile);

                                        vm.thisDropzone.emit('complete', mockFile);
                                    }
                                }
                            });
                    }
                },
                success(file, filename) {
                    vm.lastSuccessFile = file;
                    vm.lastSuccessFileUrl = '/files/'+filename[0];
                    vm.useValue = filename[0];
                    vm.$emit('update:value',filename[0]);
                },
                error(file, errorMessage) {
                    if (errorMessage != 'You can not upload any more files.') {
                        this.removeAllFiles();

                        if (vm.lastSuccessFile) {
                            this.options.addedfile.call(this, vm.lastSuccessFile);
                            this.files.push(vm.lastSuccessFile);
                            this.emit('complete', vm.lastSuccessFile);
                            vm.useValue = vm.lastSuccessFile.name;
                            vm.$emit('update:value',vm.lastSuccessFile.name);
                        }

                        if (typeof errorMessage == 'object') {
                            alert(window.t('general_upload_error'));
                        }
                    }
                },
                headers: {
                    'X-CSRF-TOKEN': document.head.querySelector("[name~=csrf-token][content]").content
                }
            })
        },
        methods: {
            uniqid() {
                var cc = 'abcdefghijklmnopqrstuvwxyz';

                return cc[Math.round(Math.random() * cc.length-1)] + Math.random().toString().substr(2, 9) + cc[Math.round(Math.random() * cc.length-1)];
            },
        }
    }
</script>
